import { LocalStorageHelper, ObjectToStore } from '../models';

export class localStorageHelper implements LocalStorageHelper {
	constructor(private readonly key: string, private readonly ttlInMilliseconds = 60000) {}

	private expired(ttl: number | undefined): boolean {
		return ttl ? ttl < Date.now() : true;
	}

	private getObjectToStore(data: string): ObjectToStore {
		return {
			data,
			ttl: Date.now() + this.ttlInMilliseconds,
		};
	}

	private parseStoredValue(storedValue: string): string | null {
		const json = JSON.parse(storedValue) as ObjectToStore;
		return this.expired(json?.ttl) ? null : json.data;
	}

	get(): string | null {
		const storedValue: string | undefined = localStorage.getItem(this.key);
		return !storedValue ? null : this.parseStoredValue(storedValue);
	}

	set(data: string): void {
		const objectToStore = this.getObjectToStore(data);
		localStorage.setItem(this.key, JSON.stringify(objectToStore));
	}
}
